import React, { useState } from 'react';

const RefineButton = ({ text, onRefined, apiUrl }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleRefine = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify({ text }),
      });
      const data = await res.json();
      if (res.ok && data.refined) {
        onRefined(data.refined);
      } else {
        console.log("error in the refining")
        setError(data.error || 'Refinement failed.');
      }
    } catch (err) {
      setError('Network error.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button
        className="btn btn-outline-info btn-sm"
        onClick={handleRefine}
        disabled={loading}
        style={{ borderRadius: '1.5rem', fontWeight: 'bold', minWidth: 90 }}
      >
        <span role="img" aria-label="magic">✨</span> {loading ? 'Refining...' : 'Refine'}
      </button>
      {error && <div className="text-danger mt-2">{error}</div>}
    </div>
  );
};

export default RefineButton;